<template>
  <v-autocomplete
    :clearable="canClear"
    :items="dispItems"
    :loading="loading"
    :search-input.sync="search"
    :value="value"
    @focus="dropdown"
    ref="ctrl"
    v-bind="$attrs"
    v-on="$listeners"
  ></v-autocomplete>
</template>
<script>
export default {
  props: ['url', 'value', 'filter', 'init', 'all'],
  data() {
    return {
      loading: false,
      clearable: true,
      search: null,
      items: [],
    }
  },
  computed: {
    canClear() {
      if (this.$attrs.clearable === undefined) return true
      return this.$attrs.clearable
    },
    dispItems() {
      if (this.filter) {
        return this.items.filter(this.filter)
      } else {
        return this.items
      }
    },
  },
  mounted() {
    if (this.value || this.filter) {
      this.load()
    }
  },
  watch: {
    search(val) {
      this.load(val)
    },
    url() {
      this.load()
    },
    value(val) {
      if (val && this.items.length === 0) {
        this.load().then(() => {
          this.onSelected()
        })
      } else {
        this.onSelected()
      }
    },
  },

  methods: {
    onSelected() {
      if (this.value) {
        let selected = this.dispItems.find(
          (i) => i[this.$refs.ctrl.itemValue] === this.value
        )
        if (selected) {
          this.$emit('item', selected)
        } else {
          this.$emit('item', null)
        }
      } else {
        this.$emit('item', null)
      }
    },
    dropdown() {
      if (this.items.length === 0) {
        this.load()
      }
    },
    load(term) {
      this.loading = true
      return this.$http
        .get(this.url, {
          params: { term: term },
          quiet: true,
          clearCache: true,
        })
        .then((res) => {
          this.items = res.data
          if (this.all) {
            this.items = [this.all, ...res.data]
          }
          this.onSelected()
          if (this.init) {
            let result = this.dispItems.find(this.init)
            if (!result) return
            this.$emit(
              'input',
              this.$refs.ctrl.returnObject
                ? result
                : result[this.$refs.ctrl.itemValue]
            )
          }
          this.loading = false
          this.$emit('obtainedData', this.items)
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
